import React from 'react';

const LABELS = { myr: 'RM', usd: 'USD' };

// Pill switch between the billing currencies the server offers (hidden when there is only one)
export default function CurrencyToggle({ currencies, value, onChange }) {
  if (!currencies || currencies.length < 2) return null;
  return (
    <div dir="ltr" style={{
      display: 'inline-flex', padding: 3, borderRadius: 999,
      background: 'var(--card-bg)', border: '1px solid var(--border)',
    }}>
      {currencies.map(c => (
        <button key={c} type="button" onClick={() => onChange(c)} style={{
          padding: '5px 16px', borderRadius: 999, border: 'none', cursor: 'pointer',
          fontSize: 12, fontWeight: 700, fontFamily: 'inherit', letterSpacing: '0.5px',
          background: c === value ? 'var(--navy)' : 'transparent',
          color: c === value ? '#fff' : 'var(--text-muted)',
        }}>{LABELS[c] || c.toUpperCase()}</button>
      ))}
    </div>
  );
}
